import React from 'react'
import { useNavigate } from 'react-router-dom';

import Footer from '../../../components/common/Footer';
import FormAction from '../../../components/common/FormAction';
import PageHeading from '../../../components/common/PageHeading'
import RightBar from '../../../components/common/RightBar'
import SubHeading from '../../../components/common/SubHeading';

import { Checkbox, Col, Form, InputNumber, Row } from 'antd';
import { TbCurrencyDollar } from 'react-icons/tb';

import "./RentalApplicationFees.css";
import RightBarMethod from '../../../components/common/RightBar/RightBarMethod';

const RentalApplicationFeesRightBar = [
    RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
        RightBarMethod("Customize Application", "1", "", "", ""),
        RightBarMethod("Bulk Update Application Fees", "2", "", "", "/leasing/rental-applications/bulk-update-application-fees"),
      ]),
      RightBarMethod("HELP TOPICS", "t2", <i className="fa-solid fa-circle-question"></i>, [
        RightBarMethod("Admin Fees", "3", "", "", ""),
      ]),
];

function RentalApplicationFees() {
    const navigate = useNavigate();
  return (
    <>
        <div className='page-container'>
        <div className="rental-application-fees main-container">
            <PageHeading heading="Rental Application Fees" />
            <Form layout='vertical'>
            <Row gutter={32}>
                    <Col span={24} className="col-container">
                        <SubHeading subHeading="Default Fees" />
                        <p className='common-paragraph'>Setting a default application fee automatically sets this fee for any new units you create. It will not override any unit-specific fees you have set. To override fees in bulk, use <span className='onlick-text' onClick={()=>navigate("/generalsettings/rental-application-fees/update-fees")}>Bulk Update Application Fees.</span></p>
                        <Form.Item label="Default Application Fee">
                            <InputNumber addonBefore={<TbCurrencyDollar size={16} /> } />
                        </Form.Item>
                    </Col>
                    <Col span={24} className="col-container">
                        <SubHeading subHeading="Admin Fees" />
                        <p className='common-paragraph'>An admin fee is an additional charge on rental applications. The admin fee is set per property and will be collected from the primary applicant (one admin fee collected per grouped application).</p>
                        <Form.Item>
                            <Checkbox>Enable admin fees</Checkbox>
                        </Form.Item>
                    </Col>
                    <Col span={24} className="col-container">
                        <SubHeading subHeading="Online Payments" />
                        <p className='common-paragraph'>Requiring payments to be made online increases chances of applicants completing the process, and saves time collecting fees. Any unit with a $0 fee will allow applicants to skip the payment section.</p>
                        <Form.Item>
                            <Checkbox>Require applicants to pay fees online</Checkbox>
                        </Form.Item>
                    </Col>
            </Row>
            <FormAction />
            </Form>
            <Footer />
        </div>
        </div>
        <div className="RightSideBar">
            <RightBar RightBarData={RentalApplicationFeesRightBar}/>
        </div>
    </>
  )
}

export default RentalApplicationFees;
